import React from 'react';

function DeleteAccount() {

    const handleDeleteAccount = (e, token) => {
        e.preventDefault();
        if(window.confirm("Are you sure you want to delete your account and cancel your subscription?")) {
            fetch(process.env.REACT_APP_DELETEACCOUNT + token, {
                method: 'post',
                mode: 'cors',
                headers: {
                    "Content-type" : "application/json"
                }
            }).then(response => response.json()).then(json => {
                alert(json.message);
                if(json.success) {
                    window.location.replace('/');
                }
            })
        } else {
            alert("Account not deleted.")
        }
    }

    return ( 
        <div className="row pt-5 mb-5">
            <form className="col-12 text-center" onSubmit={(e) => handleDeleteAccount(e, localStorage.getItem("token"))}>
                <button type="submit" className="btn btn-danger btn-lg w-100 p-4">
                    <h1 className="text-white">CANCEL SUBSCRIPTION AND DELETE ACCOUNT</h1>
                </button>
            </form>
        </div>
     );

}

export default DeleteAccount;